import React from "react";
import { AuthProvider } from "./context/AuthContext";
import { MenuProvider } from "./context/MenuContext";
import AppRoutes from "./routes/AppRoutes";
import "./App.css";

export default function App() {
  return (
    <AuthProvider>
      <MenuProvider>
        <AppRoutes />
      </MenuProvider>
    </AuthProvider>
  );
}
